import { render, staticRenderFns } from "./Cordoba.vue?vue&type=template&id=35636136&scoped=true"
import script from "./Cordoba.vue?vue&type=script&lang=js"
export * from "./Cordoba.vue?vue&type=script&lang=js"
import style0 from "./Cordoba.vue?vue&type=style&index=0&id=35636136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35636136",
  null
  
)

export default component.exports